const themes = {
	light: {
		primaryTextColor: '#BCBCBC', // main color of text
		secondaryTextColor: '#686869', // secondary color of text
		additionalTextColor: '#FFF', // secondary color of text
		extraTextColor: '#8D8D8D', // secondary color of text
		placeholderTextColor: 'rgba(255, 255, 255, .3)',

		linkTextColor: '#8D8D8D',
		propertyTextColor: '#6294F5',

		disabledTextColor: '#979797', // disabled color of text
		dangerTextColor: '#FF2C2C', // danger color of text
		noteTextColor: '#C5C7CD', // note color of text

		primaryBorderColor: '#363636',
		secondaryBorderColor: '#FFF',
		extraBorderColor: '#979797',
		additionalBorderColor: '#D9D9D9',
		disabledBorderColor: '#C5C7CD',
		primaryBackgroundColor: '#111113', // main color of bg
		widgetColor: '#161618',
    secondaryBackgroundColor: '#1D1F2B',
		disabledColor: '#DFE0EB',
		primaryColor: '#111113', // main color of bg
		secondaryColor: '#363740', // secondary coplor of bg
		blankColor: '#111113', // secondary coplor of bg
		backgroundColor: '#111113',
		additionalBackgroundColor: '#F7F8FA',
		menuItemActive: '#E4EDFF',

		primaryHighlightColor: '#0C5EFF',
		secondaryHighlightColor: '#4047EC',
		invertedCommunityColor: '#4B2FF5',
	
		buttonActionBackgroundColor: '#0C5EFF',
		buttonActionBackgroundHoverColor: '#357AFF',
		buttonActionBackgroundActiveColor: '#095AF5',

		buttonDisabledBackgroundColor: 'rgba(255, 255, 255, .4)',

		buttonDefaultBackgroundColor: 'transparent',
		buttonDefaultBackgroundHoverColor: '#363636',
		buttonDefaultBackgroundActiveColor: '#363636',

		buttonDefaultBorderHoverColor: '#121212',
		buttonDefaultBorderActiveColor: '#121212',


		buttonAdditionalTextColor: 'rgba(255, 255, 255, .67)',
		buttonAdditionalBackgroundColor: '#3A3A41',
		buttonAdditionalBackgroundHoverColor: '#3A3A41',
		buttonAdditionalTextHoverColor: 'rgba(255, 255, 255, .67)',
		buttonAdditionalBackgroundActiveColor: '#3A3A41',
		buttonAdditionalTextActiveColor: 'rgba(255, 255, 255, .67)',


		buttonDangerTextColor: '#FF5252',

		buttonGradient: 'linear-gradient(to right, #00B2FF 0%, #FA00FF 50%, #00B2FF 100%)',

		tagDefaultBackgroundColor: '#E4E4E4',
		tagDefaultBorderColor: '#9D9D9D',

		tagErrorBackgroundColor: '#FFB4B4',
		tagErrorBorderColor: '#D71E1E',

		tagInfoBackgroundColor: '#FDF0CE',
		tagInfoBorderColor: '#F6B40A',
	
		tagSuccessBackgroundColor: '#D1FAE1',
		tagSuccessBorderColor: '#19E46A',

		tagAdditionalBackgroundColor: '#DEF1FE',
		tagAdditionalBorderColor: '#5CB9FC',


		// grey
		statusBarDefaultBackgroundColor: '#E4E4E4',
		statusBarDefaultBorderColor: '#9D9D9D',

		// yellow
		statusBarInfoBackgroundColor: '#FDF0CE',
		statusBarInfoBorderColor: '#F6B40A',
	
		// green
		statusBarSuccessBackgroundColor: '#D1FAE1',
		statusBarSuccessBorderColor: '#19E46A',




		noteDefaultBackgroundColor: '#1E1E1F',

		noteWarningBackgroundColor: '#FFB4B4',
		noteWarningTextColor: '#D71E1E',
		noteWarningBorderColor: '#D71E1E',

		statusSuccessColor: '#19E46A',
		statusStoppedColor: '#DFE0EB',



		audienceBackgroundColor: '#161618',
		audienceTextColor: '#545454',
		audienceBorderColor: '#1E1E1F',

		audienceDisabedBackgroundColor: '#161618',
		audienceDisabledTextColor: '#545454',
		audienceDisabledBorderColor: '#1E1E1F',

		audienceActiveBackgroundColor: '#1E1E1F',
		audienceActiveTextColor: '#8D8D8D',
		audienceActiveBorderColor: '#2C2C2F',



		stageDoneBackgroundColor: 'rgb(255, 216, 98, .15)',
		stageDoneBorderColor: 'transparent',
		stageDoneIconColor: '#FFD862',
		stageDoneTextColor: 'rgba(188, 188, 188, .4)',


		stageCurrentBackgroundColor: 'transparent',
		stageCurrentBorderColor: 'rgb(255, 216, 98, .15)',
		stageCurrentIconColor: '#BCBCBC',
		stageCurrentTextColor: '#BCBCBC',


		stageNextBackgroundColor: 'transparent',
		stageNextBorderColor: '#202022',
		stageNextIconColor: 'rgba(188, 188, 188, .4)',
		stageNextTextColor: 'rgba(188, 188, 188, .4)',

		inputIconZoneBackgroundColor: '#19191A',

		
		tokenCounterBackgroundFilledColor: 'rgba(56, 150, 106, .05)',
		tokenCounterBackgroundColor: '#1A1A1C',

		dropStatusTextColor: '#38966A',


		switcherItemBackgroundColor: '#242426',
		switcherTagBackgroundColor: '#2A271F',
		switcherTagTextColor: '#A0873C'

	},
	dark: {
		primaryTextColor: 'red',
		secondaryTextColor: '#363740',
		primaryBorderColor: '#DFE0EB',
		secondaryBorderColor: '#FFF',
		primaryColor: '#1E1E1E',
		secondaryColor: '#363740',
		menuItemActive: '#3E4049'
	}
}

export default themes